<template>
  <div class="cbg-white-container input-container theme--light v-card border-card">
    <div class="col-sm-12 pl-0 pr-0">
      <v-row class="m-0">
        <v-col md="4" sm="6" class="col-12">
          <label for class="fz-12px">Referred name / Referral Code No</label>
          <div class="search-div position-relative">
            <input
              class="form-control"
              label="Search by Name"
              placeholder="Name"
              v-model="search"
              @input="debounceSearch()"
            />
            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" class="col-12 datepicker pos-r">
          <label for>Date Range</label>
          <div>
            <datepicker
              v-model="dateRange"
              @input="dateChange()"
              ref="datepicker"
              :model-config="datePickerConfig"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD/MM/YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="
                    !!inputValue.start && !!inputValue.end
                      ? inputValue.start + ' - ' + inputValue.end
                      : 'DD/MM/YYYY'
                  "
                  v-on="inputEvents.start"
                  class="form-control position-relative"
                  placeholder="DD/MM/YYYY"
                />
                <div
                  v-if="!!inputValue.start && !!inputValue.end"
                  class="cross-svg"
                  @click="resetActiveDate"
                >
                  <crossSVG />
                </div>
              </template>
            </datepicker>
            <div class="calendarsvg userinputcalendar pos-a">
              <calendarSVG />
            </div>
          </div>
        </v-col>

        <v-col md="4" sm="6" class="col-12">
          <div class="position-relative">
            <label for>Role</label>
            <select name id class="form-control" v-model="role" @change="roleChange()">
              <option value="all">All</option>
              <option value="patient">Patient</option>
              <option value="doctor">Doctor</option>
              <option value="pharmacy">Pharmacy</option>
              <option value="ambulance">Ambulance</option>
              <option value="diagnostics-lab">Diagnostics</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </v-col>
      </v-row>
    </div>
    <!-- ................. -->
    <loader v-if="showLoader"></loader>
    <v-col cols="12" class="mt-2">
      <div class="table-div overflow-auto">
        <table class="table userlistTable small-table-width">
          <thead>
            <tr class="table-success">
              <th scope="col">Date of joining</th>
              <th scope="col">Referred username</th>
              <th scope="col">Contact number (of referred)</th>
              <th scope="col">Role</th>
              <th scope="col">Referred by</th>
              <th scope="col">Referral Code (used)</th>
              <th scope="col">Subcription</th>
            </tr>
          </thead>
          <tbody v-if="!isEmpty">
            <tr v-for="(list, i) in referencedUserList" :key="i">
              <td>
                <div>{{ dayJS(list.createdAt).format(formats.date_format) }}</div>
              </td>
              <td>
                <div>{{ list.full_name }}</div>
              </td>
              <td>
                <div>{{ list.mobile }}</div>
              </td>
              <td>
                <div>{{ list.default_profile ? list.default_profile : "&#8213;" }}</div>
              </td>
              <td>
                <div>{{ list.referenced_by.full_name }}</div>
              </td>
              <td>
                <div>{{ list.referenced_by.reference_code.code }}</div>
              </td>
              <td>
                <div>&#8213;</div>
              </td>
            </tr>
          </tbody>
          <tbody v-if="isEmpty">
            <tr>
              <td colspan="8">
                <h2 class="text-center">No Data Found</h2>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-col>
    <!-- ................. -->
    <pagination
      class="mx-3 pagination-block"
      :recordPerPage="recordPerPage"
      :total="total"
      @changePage="pageChange"
      v-if="!isEmpty"
    />
  </div>
</template>
<script>
import config from "@/config.js";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
import debounce from "lodash/debounce";
import formats from "@/formats";
const pagination = () => import("@/views/common/Pagination");
const loader = () => import("@/components/loader.vue");
import { pickSvg } from "@/views/SVG";
export default {
  components: {
    Datepicker,
    pagination,
    loader,
    ...pickSvg("crossSVG ")
  },
  data() {
    return {
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      dayJS,
      formats,
      search: "",
      showLoader: false,
      currentPage: 1,
      recordPerPage: 10,
      totalPage: 0,
      dateRange: {
        start: "",
        end: ""
      },
      referencedUserList: [],
      isEmpty: false,
      isCompleted: "",
      role: "all",
      total: 0
    };
  },
  mounted() {
    this.getReferencedUsers();
  },
  methods: {
    resetActiveDate() {
      this.dateRange = { start: "", end: "" };
      this.getReferencedUsers();
    },
    debounceSearch: debounce(function() {
      this.getReferencedUsers();
    }, 500),
    dateChange() {
      this.getReferencedUsers();
    },
    clearSearch() {
    this.search = "";
    this.getReferencedUsers();
  },
    pageChange(page) {
      this.currentPage = page.currentPage;
      this.getReferencedUsers();
    },
    roleChange() {
      this.getReferencedUsers();
    },
    getReferencedUsers() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        start_date: this.dateRange.start.toString(),
        end_date: this.dateRange.end.toString(),
        role_filter: this.role,
        search_text: this.search
      };
      let url = `${config.BASE_URL}api/v2/admin/referenced-users`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
            this.referencedUserList = response.body.data.list;
          } else {
            this.referralUserList = [];
            this.isEmpty = true;
          }
        }
      });
    }
  }
};
</script>